import React, { useState, useEffect, useContext } from "react";

import FormSectionLayout from "../../layouts/FormSectionLayout";
import HeadingText from "../../common/HeadingText/HeadingText";
import { Container, Form, Row, Col } from "reactstrap";
import "./AddUpdatePromosCityLevelPage.scss";
import ButtonComponent from "../../common/Button/ButtonComponent";

import {
  IAddBulkPromosCityLevelPageProps,
  IDeactivateBulkPromosPageProps,
} from "../../../interfaces/Index";
import LoaderComponent from "../../common/Loader/Loader";
import { _ } from "../../../utils/lib";
import { AbilityContext } from "../../../config/Can";
import {
  PROMO_OPTIONS,
  PROMO_TYPE_CONST,
} from "./constants/PromosCityLevelConstants";
import { SelectDropDown } from "../../common/SelectDropDown/SelectDropDown";
import { acceptableFormats } from "config/constants";
import UploadButtonComponent from "../../common/UploadButton/UploadButtonComponent";
import backArrow from "assets/images/back_arrow.svg";
import { IDeactivateUserLevelBulkPromoState } from "interfaces/userLevelPromo.interface";

const DeactivateBulkPromoPage: React.FunctionComponent<
  IDeactivateBulkPromosPageProps
> = (props) => {
  const ability = useContext(AbilityContext);

  const [userLevelPromoState, setUserLevelPromoState] =
    useState<IDeactivateUserLevelBulkPromoState>({
      promoDetailsCsvFile: null,
      promoDetailsCsvFileName: "",
    });

  useEffect(() => {
    const { error, isError } = props;
    if (isError) {
      alert((error! as any).errors);
    }
  }, [props.isError]);

  useEffect(() => {
    const { isPromoUpdated, backButtonHandler, clearPromoDetails } = props;
    if (isPromoUpdated) {
      backButtonHandler(true);
      setTimeout(() => {
        clearPromoDetails();
      }, 100);
    }
  }, [props.isPromoUpdated]);

  const headingText = "Deactivate Bulk Promo";

  const buttonText = "Deactivate";

  const handleGoBackButton = () => {
    const { clearPromoDetails, backButtonHandler, selectedCity } = props;
    clearPromoDetails();
    backButtonHandler(false, selectedCity);
  };

  const handleSubmit = () => {
    const { deactivateUserLevelPromoBulk } = props;
    const { promoDetailsCsvFile } = userLevelPromoState;

    if (promoDetailsCsvFile) {
      const formData = new FormData();
      formData.append("promoIdsFile", promoDetailsCsvFile);
      deactivateUserLevelPromoBulk(formData);
    }
  };

  const handlePromoDetailsCSVInputChange = (file: any) => {
    if (file) {
      setUserLevelPromoState({
        ...userLevelPromoState,
        promoDetailsCsvFile: file,
        promoDetailsCsvFileName: file.name,
      });
    }
  };

  const handlePromoDetailsCSVRemove = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    setUserLevelPromoState({
      ...userLevelPromoState,
      promoDetailsCsvFile: null,
      promoDetailsCsvFileName: "",
    });
  };

  const renderPromoDetail = () => {
    return (
      <FormSectionLayout subTitleText="Promo details">
        <div className="form-row">
          <Col>
            <SelectDropDown
              label="Type"
              disabled={true}
              options={PROMO_OPTIONS}
              id="promoType"
              handleChange={() => console.log("value")}
              value={PROMO_TYPE_CONST.ULP}
              defaultOption={{
                id: "-1",
                value: "Select promo type",
                text: "Select promo type",
              }}
            />
          </Col>
        </div>
      </FormSectionLayout>
    );
  };

  const renderPromoDetailsCSV = () => (
    <div className="user-level-upload-component-container-wrapper bulk-upload-container">
      <Row>
        <Col lg="6">
          <UploadButtonComponent
            id="upload-promo-details-csv"
            buttonText={
              userLevelPromoState.promoDetailsCsvFile
                ? userLevelPromoState.promoDetailsCsvFileName
                : "Upload .CSV "
            }
            fileFormat={acceptableFormats.csv}
            fileUploaded={!!userLevelPromoState.promoDetailsCsvFile}
            handleRemoveFile={handlePromoDetailsCSVRemove}
            handleFileChange={handlePromoDetailsCSVInputChange}
            classes="large-button btn-primary promo-upload-btn"
          />
        </Col>
      </Row>
      <div className="btn-primary-outline button-large btn btn-secondary no-border-btn d-flex justify-content-between align-items-center">
        <a
          href={require("../../../assets/static/promo-bulk-deactivation.csv")}
          target="_blank"
          className=""
        >
          <small>Download Sample </small>
        </a>
      </div>
    </div>
  );

  const renderFormButton = () => {
    return (
      <div className="form-row-separator">
        <Row id="addEditButtonRow" className="add-update-button-container">
          <Col lg="6">
            <ButtonComponent
              buttonClass="large-button btn-primary"
              buttonText={buttonText}
              onClickHandler={handleSubmit}
              isDisable={
                props.isLoading || !userLevelPromoState.promoDetailsCsvFile
              }
            />
          </Col>
        </Row>
      </div>
    );
  };

  //main control of return UI
  return (
    <Container fluid>
      {props.isLoading && <LoaderComponent />}
      <Row>
        <Col lg="5">
          <div className="back-button">
            <a href="javascript:void(0)" onClick={handleGoBackButton}>
              {" "}
              {/* TO-DO: Convert this to a button in all compoents. */}
              <span>
                <img src={backArrow} alt="close" />
              </span>{" "}
              Back to Promos
            </a>
          </div>
          <HeadingText text={headingText} isMainHeading={true} />
        </Col>
      </Row>
      <Row className="form-container">
        <Col xs="12">
          <Form>
            <div className="promos-detail">{renderPromoDetail()}</div>
            <div className="promo-criteria form-row-separator">
              <FormSectionLayout subTitleText="Promo Details CSV">
                {renderPromoDetailsCSV()}
                {renderFormButton()}
              </FormSectionLayout>
            </div>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default DeactivateBulkPromoPage;
